import { useState } from 'react';

const useLocation = () => {
  const [location, setLocation] = useState(null);

  const fetchLocation = () => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const loc = { lat: pos.coords.latitude, lng: pos.coords.longitude };
          setLocation(loc);
          resolve(loc);
        },
        (err) => {
          console.error('Location error:', err);
          reject(err);
        },
        { timeout: 10000, maximumAge: 0 }
      );
    });
  };

  return { location, fetchLocation };
};

export default useLocation;